import { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';
import { toQueryParams } from 'api/apiUtils';

export const getRunnerTE = <E = CF.API.ApiError>(
  { userId, clusterId, nodepoolId, runnerId }: { userId: string; clusterId: string; nodepoolId: string; runnerId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.GetRunnerResponse> =>
  fetchTE<CF.API.Compute.GetRunnerResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners/${runnerId}`,
      method: 'GET',
    },
    onRejected,
  );

export const listRunnersTE = <E = CF.API.ApiError>(
  { userId, clusterId, nodepoolId }: { userId: string; clusterId: string; nodepoolId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListRunnersResponse> =>
  fetchTE<CF.API.Compute.ListRunnersResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners`,
      method: 'GET',
    },
    onRejected,
  );

export const listAllRunnersTE = <E = CF.API.ApiError>(
  { userId, modelVersionIds }: { userId: string; modelVersionIds?: string[] },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListRunnersResponse> =>
  fetchTE<CF.API.Compute.ListRunnersResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/runners${modelVersionIds ? `?${toQueryParams(modelVersionIds, 'model_version_ids')}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );

export const deleteRunnersTE = <E = CF.API.ApiError>(
  { userId, clusterId, nodepoolId, runnerIds }: { userId: string; clusterId: string; nodepoolId: string; runnerIds: string[] },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, { status: CF.API.Status }> =>
  fetchTE<{ status: CF.API.Status }, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners`,
      method: 'DELETE',
      body: { ids: runnerIds },
    },
    onRejected,
  );
